import React, { useState, useEffect } from "react";
import { Routes, Route, Link } from "react-router-dom";
import Pedidos from "../components/Cuenta/Pedidos";
import ProductosSuscripcion from "../components/Cuenta/ProductosSuscripcion"; // Importar el nuevo componente
import Referidos from "../components/Cuenta/Referidos"; // Importar el componente de referidos
import AccountStatus from "../components/Cuenta/AccountStatus"; // Importar el componente de estado de la cuenta
import DetallesCuenta from "../components/Cuenta/DetallesPerfil"; // Importar el componente de perfil del usuario
import profilePicture from "../assets/img/foto-perfil.png"; // Importar la foto de perfil

const menuItems = [
  { name: "Mi Cuenta", href: "/mi-cuenta", element: <AccountStatus /> }, // Mostrar AccountStatus en Mi Cuenta
  { name: "Facturación", href: "/mi-cuenta/facturacion", element: <Pedidos /> },
  { name: "Servicios", href: "/mi-cuenta/servicios", element: <ProductosSuscripcion /> }, // Usar el componente ProductosSuscripcion
  { name: "Saldo", href: "/mi-cuenta/saldo", element: <p>Revisa tu saldo disponible y los movimientos recientes.</p> },
  { name: "Referidos", href: "mi-cuenta/referidos", element: <Referidos /> }, // Usar el componente Referidos
  { name: "Perfil", href: "/mi-cuenta/perfil", element: <DetallesCuenta /> }, // Usar el componente de DetallesPerfil
  { 
    name: "Ayuda", 
    href: "#", 
    subMenu: [
      { name: "Solicitar Canal", href: "/mi-cuenta/ayuda/solicitar-canal", element: <p>Solicitar un nuevo canal</p> },
      { name: "Instalación de APK", href: "/mi-cuenta/ayuda/instalacion-apk", element: <p>Guía para instalación de APK</p> },
      { name: "FAQs", href: "/mi-cuenta/ayuda/faqs", element: <p>Preguntas frecuentes</p> },
    ],
  },
];
const MiCuenta = () => {
  const [userData, setUserData] = useState({
    avatar: profilePicture,
    name: "Lorenzo Picado Campos",
    email: "hoyvemos.com@gmail.com",
    lastConnection: "hace 4 meses",
    clientSince: "19 de junio de 2024",
  });

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <aside className="min-w-[312px] w-[20%] bg-white text-black border-r border-gray-300">
        <div className="px-6 py-4">
          <div className="flex flex-col items-center mb-6">
            <img
              src={userData.avatar}
              alt={userData.name}
              className="h-20 w-20 rounded-full mb-4"
            />
            <h2 className="text-xl font-bold text-center">{userData.name}</h2>
            <p className="text-gray-500 text-sm text-center">{userData.email}</p>
            <p className="text-gray-400 text-sm text-center">Última conexión: {userData.lastConnection}</p>
            <p className="text-gray-400 text-sm text-center">Cliente desde: {userData.clientSince}</p>
          </div>
          <h2 className="text-lg font-semibold mb-4">Panel de Usuario</h2>
        </div>
        <nav className="space-y-2">
          {menuItems.map((item) => (
            item.subMenu ? (
              <div key={item.name} className="group">
                <button className="block px-6 py-2 w-full text-left text-gray-700 hover:bg-gray-200 rounded-md">
                  {item.name}
                </button>
                <div className="hidden group-hover:block pl-4">
                  {item.subMenu.map((subItem) => (
                    <Link
                      key={subItem.name}
                      to={subItem.href}
                      className="block px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-md"
                    >
                      {subItem.name}
                    </Link>
                  ))}
                </div>
              </div>
            ) : (
              <Link
                key={item.name}
                to={item.href}
                className="block px-6 py-2 text-gray-700 hover:bg-gray-200 rounded-md"
              >
                {item.name}
              </Link>
            )
          ))}
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-grow bg-gray-100 p-6">
        {/* Routes */}
        <Routes>
          {menuItems.map((item) => (
            item.subMenu
              ? item.subMenu.map((subItem) => (
                  <Route
                    key={subItem.name}
                    path={subItem.href.replace("/mi-cuenta", "")}
                    element={subItem.element}
                  />
                ))
              : (
                <Route
                  key={item.name}
                  path={item.href.replace("/mi-cuenta", "")}
                  element={item.element}
                />
              )
          ))}
          <Route path="*" element={<p>Selecciona una opción en el menú para continuar.</p>} />
        </Routes>
      </main>
    </div>
  );
};

export default MiCuenta;
